import { useRef } from "react";
import gsap from "gsap";

export const Tilt3D = ({ children, className = "", max = 10, glare = true, ...rest }) => {
  const ref = useRef(null);
  const glareRef = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    gsap.to(el, { rotateY: px * max * 2, rotateX: -py * max * 2, translateZ: 12, duration: 0.5, ease: "power2.out", transformPerspective: 900 });
    if (glareRef.current) gsap.to(glareRef.current, { opacity: 0.35, x: `${px * 60}%`, y: `${py * 60}%`, duration: 0.5 });
  };
  const onLeave = () => {
    gsap.to(ref.current, { rotateY: 0, rotateX: 0, translateZ: 0, duration: 0.8, ease: "elastic.out(1, 0.6)" });
    if (glareRef.current) gsap.to(glareRef.current, { opacity: 0, duration: 0.6 });
  };

  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} className={`tilt-card relative overflow-hidden ${className}`} {...rest}>
      {children}
      {glare && <span ref={glareRef} className="pointer-events-none absolute inset-0 opacity-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.18), transparent 60%)" }} />}
    </div>
  );
};
